import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";

interface CustomerProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Garde-fou pour les pages du portail client (`/client/*`).
 *
 * - Si non authentifié : redirection vers `/login` (et mémorisation de la cible).
 * - Si authentifié mais rôle différent de `CUSTOMER` (ex. ADMIN connecté sur le navigateur) :
 *   redirection vers `/dashboard` (espace staff).
 */
export function CustomerProtectedRoute({
  children,
}: CustomerProtectedRouteProps): JSX.Element {
  const location = useLocation();
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user && user.role !== "CUSTOMER") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
